export enum AuthNewLocalStorage {
    OAuthLoggedIn = 'OAuthLoggedIn',
}
